import { API_URL_ARTIST } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const banArtist = (uuid: string) =>
  apiInstance({
    url: `${API_URL_ARTIST}${uuid}/banned`,
    method: "put",
  });

export default banArtist;
